import type ErrorStatus from '$shared/constants/ErrorStatus';
import ServiceError from '$shared/models/ServiceError';
import { AppException } from './AppException';

export class UnhandledException extends AppException {
  public readonly name: string;
  public readonly serviceErr: ServiceError;

  constructor(name: string, err: ServiceError | Error, data: unknown) {
    super(err, data, true);
    this.name = name;
    err instanceof ServiceError && (this.serviceErr = err);
  }

  public get title(): string {
    return this.serviceErr?.title || this.serviceErr?.message || '';
  }

  public get status(): ErrorStatus | undefined {
    return this.serviceErr?.status || this.data?.status;
  }

  override get extras(): any {
    return { type: 'Unhandled', name: this.name };
  }

  static from(name: string, err: ServiceError | Error, data: unknown): UnhandledException {
    return new UnhandledException(name, err, data);
  }
}
